export const useAccountSearch = (locationPath: string): { isShowSearch: boolean } => {
  const isShowSearch = !locationPath.includes('add-lookup');
  return { isShowSearch };
};
